import Vue from 'vue'
import { Toast } from 'vant'
import { JSEncrypt } from 'jsencrypt'
import { serverUrl } from '@/api/baseMap'
import wx from 'weixin-js-sdk'
import { getPayInfo, getPayWXInfo, getPayInfoNew, applyWechatpayNew } from '@/api/pay'
import { getQiNiuToken } from '@/api/vehicleHandle'
import { isWebAndroid, isApp } from './judgeEnv'
import loadMap from './loadMap'
const qiniu = require('qiniu-js')
const CryptoJS = require('crypto-js')

Vue.use(Toast)

// 深拷贝
function deepCopy(obj) {
  var result = Array.isArray(obj) ? [] : {}
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (typeof obj[key] === 'object' && obj[key] !== null) {
        result[key] = deepCopy(obj[key]) //递归复制
      } else {
        result[key] = obj[key]
      }
    }
  }
  return result
}

// url 参数
function getUrlParam(urlStr = location.href) {
  let params = {}
  if (urlStr.indexOf('?') != -1) {
    let str = urlStr.substr(urlStr.indexOf('?') + 1)
    let strs = str.split('&')
    for (let i = 0; i < strs.length; i++) {
      params[strs[i].split('=')[0]] = decodeURI(strs[i].split('=')[1])
    }
  }
  return params
}

// 日期格式化
function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : ('00' + str).substr(str.length))
    }
  }
  return fmt
}
// 数字转换车大写
function numToCap(num) {
  switch (num) {
    case 1:
      return '周一'
    case 2:
      return '周二'
    case 3:
      return '周三'
    case 4:
      return '周四'
    case 5:
      return '周五'
    case 6:
      return '周六'
    case 0:
      return '周日'
  }
}

// 计算时间差
function computedTimeSize(startTime, endTime) {
  let otherday = 0,
    s = '',
    e = ''
  if (startTime && startTime.split(' ').length) {
    s = startTime.split(' ')[0] + ' 00:00:00'
  }
  if (endTime && endTime.split(' ').length) {
    e = endTime.split(' ')[0] + ' 00:00:00'
  }
  let timesize = new Date(endTime.replace(/-/g, '/')).getTime() - new Date(startTime.replace(/-/g, '/')).getTime()
  let timedaysSize = new Date(e.replace(/-/g, '/')).getTime() - new Date(s.replace(/-/g, '/')).getTime()
  let timedays = parseInt(timedaysSize / (24 * 60 * 60 * 1000))
  let morehours = (timesize - timedays * 24 * 60 * 60 * 1000) / (60 * 60 * 1000)
  if (morehours > 4) {
    otherday = 1
  }
  return timedays + otherday
}

// 钱 转分
function multiply(value) {
  if (value) {
    let num = (parseFloat(value) * 100).toFixed(0)
    return `${num}`
  } else {
    return ''
  }
}

// 钱 转yuan
function divide(value) {
  if (value) {
    let num = (parseFloat(value) / 100).toFixed(2)
    let n = `${parseFloat(num)}`
    if (n.indexOf('.') > -1) {
      return `${Number(n).toFixed(2)}`
    } else {
      return n
    }
  } else {
    return 0
  }
}

// rsa 加密
function Encrypt(content) {
  let public_key = ''
  if (window.env === 'prd') {
    public_key =
      'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC+oGDtS/DFKOHINfmz7+u0jKB7f7X6rJnZbDKGKQuJeVSZxnIHgPMg6jiwX3PniAkFDvitF1DTCTrQcPxB9JLCw6hS0QuAJCGyxiHgDLpOfQVm0/G2eSL/fn6OUUpnCsi0ywYHwYzP4cwlzvgSSnaMXGl5LUeI13Tnjx/iDYmbxQIDAQAB'
  } else {
    public_key =
      'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCHpnKKjVFXDzCb2xtCab0IWyH4IpHuu6QCurQ8ke9vBi9DAJVWFpz90/2MyZ9durS42U48q5xcUKORElwolEEfOcH+/CuwJCQlNCN2FiEB04Fm4KydgWOnFrIQfr5Yid7IIEu5rEaD+8/EQ5i74idLK9wTIx1p3PMo1b1l5+Xa9wIDAQAB'
  }
  // 新建JSEncrypt对象
  let encrypttor = new JSEncrypt()
  // 设置公钥
  encrypttor.setPublicKey(public_key)
  // 加密数据  base64
  return encrypttor.encrypt(content)
  // return Base64.encode(text)
}

// aes 解密
function Decrypt(str) {
  let aes_key = 'com.rv2go.rvlife'
  let vals = str.replace(/\-/g, '+').replace(/_/g, '/')
  let options = {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  }
  let key = CryptoJS.enc.Utf8.parse(aes_key)
  let decryptedData = CryptoJS.AES.decrypt(vals, key, options)
  let decryptedStr = CryptoJS.enc.Utf8.stringify(decryptedData)
  return decryptedStr
}

// 隐藏身份证号手机号中间部分
function hideNumber(str, frontLen, endLen) {
  var len = str.length - frontLen - endLen
  var xing = ''
  for (var i = 0; i < len; i++) {
    xing += '*'
  }
  return str.substring(0, frontLen) + xing + str.substring(str.length - endLen)
}

// 秒数转化为小时分钟秒数
function secondFormat(second) {
  var dd, hh, mm, ss
  second = typeof second === 'string' ? parseInt(second) : second
  if (second < 0) {
    return
  }
  //天
  dd = (second / (24 * 3600)) | 0
  second = Math.round(second) - dd * 24 * 3600
  //小时
  hh = (second / 3600) | 0
  second = Math.round(second) - hh * 3600
  //分
  mm = (second / 60) | 0
  //秒
  ss = Math.round(second) - mm * 60
  if (Math.round(dd) < 10) {
    dd = dd > 0 ? '0' + dd : ''
  }
  if (Math.round(hh) < 10) {
    hh = '0' + hh
  }
  if (Math.round(mm) < 10) {
    mm = '0' + mm
  }
  if (Math.round(ss) < 10) {
    ss = '0' + ss
  }
  return `${hh}小时${mm}分${ss}秒`
}

// 秒数转化为小时分钟秒数
function secondFormatWithDay(second) {
  var dd, hh, mm, ss
  second = typeof second === 'string' ? parseInt(second) : second
  if (second < 0) {
    return
  }
  //天
  dd = (second / (24 * 3600)) | 0
  second = Math.round(second) - dd * 24 * 3600
  //小时
  hh = (second / 3600) | 0
  second = Math.round(second) - hh * 3600
  //分
  mm = (second / 60) | 0
  //秒
  ss = Math.round(second) - mm * 60
  if (Math.round(dd) < 10) {
    dd = dd > 0 ? '0' + dd : ''
  }
  if (Math.round(hh) < 10) {
    hh = '0' + hh
  }
  if (Math.round(mm) < 10) {
    mm = '0' + mm
  }
  if (Math.round(ss) < 10) {
    ss = '0' + ss
  }
  return {
    day: dd,
    hour: hh,
    minute: mm,
    second: ss,
  }
}

// 验证取还车时间
function checkPiupDropoffTime(startTime, endTime, type, price) {
  let mesObj = {
    message: '',
    flag: 0, // 1.大于四小时，2.租期大于零，小于四小时， 3.租期等于零，小于四小时
  }
  let times = new Date(endTime).getTime() - new Date(startTime).getTime()
  let days = parseInt(times / (24 * 60 * 60 * 1000))
  let hours = (times - days * 24 * 60 * 60 * 1000) / (60 * 60 * 1000)
  if (days > 0 && hours == 0) {
    mesObj.message = ''
  } else if (hours > 4) {
    let num = days + 1
    if (type == 1) {
      mesObj.message =
        '您选择的租赁时长为' +
        days +
        '天' +
        hours +
        '小时（已达5小时），' +
        hours +
        '小时按天计算车辆租金' +
        price.dayPrice +
        '元，建议您可以选择按' +
        num +
        '天租赁然后提前还车（提前还车不返还租金），避免产生超时费用。'
    } else {
      mesObj.message =
        '您选择的租赁时长为' +
        days +
        '天' +
        hours +
        '小时（已达5小时），' +
        hours +
        '小时将额外收取一天的租金，建议您可以选择按' +
        num +
        '天租赁然后提前还车（提前还车不返还租金），避免产生超时费用。'
    }
    mesObj.flag = 1
  } else {
    if (days > 0) {
      if (type == 1) {
        let allPrice = hours * price.hourPrice
        mesObj.message =
          '您选择的租赁时长为' +
          days +
          '天' +
          hours +
          '小时（未达5小时），' +
          hours +
          '小时按' +
          price.hourPrice +
          '元/小时收取延时租赁费共计' +
          allPrice +
          '元。 '
      } else {
        mesObj.message =
          '您选择的租赁时长为' + days + '天' + hours + '小时（未达5小时），' + hours + '小时将收取延时租赁费。 '
      }
      mesObj.flag = 2
    } else {
      mesObj.message = '租车时间至少为5个小时。请重新选择！'
      mesObj.flag = 3
    }
  }
  return mesObj
}

// 获取路由参数
function getUrlData() {
  let url = window.location.href,
    urlstr = url.split('?')[1]
  if (urlstr) {
    urlstr = urlstr.split('#')[0]
    let urlarr = urlstr.split('&'),
      data = {}
    for (let i = 0; i < urlarr.length; i++) {
      let cur = urlarr[i]
      let arr = (cur + '').split('=')
      data[arr[0]] = arr[1]
    }
    return data
  } else {
    return false
  }
}

function getQueryString(location, key = null) {
  // 用?分割成，使用&符号得到每一个key=val
  let tempArr = null,
    searchObj = {}
  // 遍历数组中的每一个key=val字符串，使用=号劈开，
  // 然后以key为名，val为值添加到searchObj对象中。
  for (let i of location.split('?')[1].split('&')) {
    tempArr = i.split('=')
    searchObj[tempArr[0]] = tempArr[1]
  }
  // 有参数返回指定值，没有参数返回全部值
  return key ? searchObj[key] : searchObj
}

// 是否是字符串
function isString(value) {
  return typeof value === 'string'
}

// 是否是对象
function isObject(value) {
  return !!value && !value.tagName && objectPrototype.toString.call(value) === '[object Object]'
}

// 获取localStorage数据
function getLocalCache(key) {
  if (isString(key)) {
    return localStorage.getItem(key)
  }
}

// 设置localStorage数据
function setLocalCache() {
  var arglen = arguments.length
  if (arglen == 2) {
    localStorage.setItem(arguments[0], arguments[1])
  } else if (arglen == 1) {
    if (isObject(arguments[0])) {
      for (var i in arguments[0]) {
        localStorage.setItem(i, arguments[0][i])
      }
    } else {
      return false
    }
  } else {
    return false
  }
}

function setLocalCacheObj() {
  var arglen = arguments.length
  if (arglen == 2) {
    localStorage.setItem(arguments[0], JSON.stringify(arguments[1]))
  } else if (arglen == 1) {
    if (isObject(arguments[0])) {
      for (var i in arguments[0]) {
        localStorage.setItem(i, JSON.stringify(arguments[0][i]))
      }
    } else {
      return false
    }
  } else {
    return false
  }
}

// 获取cookie
function getCookie(name) {
  if (document.cookie.length > 0) {
    let c_start = document.cookie.indexOf(name + '=')
    if (c_start != -1) {
      c_start = c_start + name.length + 1
      let c_end = document.cookie.indexOf(';', c_start)
      if (c_end == -1) c_end = document.cookie.length
      return unescape(document.cookie.substring(c_start, c_end))
    }
  }
  return ''
}

// is iphone
function isIphone() {
  let u = navigator.userAgent
  let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
  return isIOS
}

// 是否是iphone系机型
function isIphonXSeries() {
  if (typeof window !== 'undefined' && window) {
    return /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812
  }
  return false
}

//获取openID
function shareGetOpenId(num, to) {
  let params = window.location.search
  let hrefUrl
  if (num == 1) {
    hrefUrl = window.location.origin + '/rent/v2/vehicle-detail'
    hrefUrl = hrefUrl + '?' + params
  } else if (num == 2) {
    hrefUrl = window.location.origin + '/rent/v2/order/orderList'
  } else {
    let id = to.query.id
    hrefUrl = window.location.origin + '/rent/v2/camper/camperDetail'
    hrefUrl = hrefUrl + '?id=' + id
  }
  window.location.href =
    serverUrl + '/app20/order-service/order20/api/order/payment/wechat/h5OpenId?sendUrl=' + encodeURIComponent(hrefUrl)
}

function is_weixin() {
  var ua = window.navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  } else {
    return false
  }
}

function payMoneyCommon(orderId, url = '/rent/v2/order/orderList') {
  let data = {
    orderId: orderId,
    payService: 1,
    url: location.href,
  }
  if (is_weixin()) {
    data.env = 'H5'
    data.openId = localStorage.getItem('wxOpenId') || ''
    Toast.loading({
      icon: 'https://cdn.rv2go.com/m-load.gif',
      forbidClick: true,
      duration: 0,
    })
    getPayInfoNew({ d: JSON.stringify(data) }).then((res) => {
      if (res.success) {
        Toast.clear()
        let clientType = 5
        if (window.isOtherApp) {
          clientType = isIphone() ? 1 : 2
        }
        let params1 = {
          clientType: clientType,
          orderId: res.data.orderId,
          // payEnv: "WX_JS",
          payEnv: 'H5',
          payService: res.data.payChannelConfig.payPlatformInfos[0].paymentService,
          prePayNumber: res.data.prePayNumber,
          type: res.data.payChannelConfig.payPlatformInfos[0].paymentType,
          typeCode: res.data.payChannelConfig.payPlatformInfos[0].typeCode,
          openId: localStorage.getItem('wxOpenId'),
        }
        Toast.loading({
          icon: 'https://cdn.rv2go.com/m-load.gif',
          forbidClick: true,
          duration: 0,
        })
        applyWechatpayNew({ d: JSON.stringify(params1) }).then((res) => {
          if (res.success) {
            Toast.clear()
            window.location.href = res.data.h5JumpContent
            // isWXPay(res.data, url);
          } else {
            window.location.href = url
          }
        })
      } else {
        window.location.href = url
      }
    })
  } else {
    window.location.href = `/rent/v2/pay/${orderId}`
  }
}

//微信浏览器支付判断
function isWXPay(params, url = '/rent/v2/order/orderList') {
  if (typeof WeixinJSBridge == 'undefined') {
    if (document.addEventListener) {
      document.addEventListener('WeixinJSBridgeReady', onBridgeReady(params), false)
    } else if (document.attachEvent) {
      document.attachEvent('WeixinJSBridgeReady', onBridgeReady(params))
      document.attachEvent('onWeixinJSBridgeReady', onBridgeReady(params))
    }
  } else {
    onBridgeReady(params, url)
  }
}

//微信浏览器支付
function onBridgeReady(params, url = '/rent/v2/order/orderList') {
  WeixinJSBridge.invoke(
    'getBrandWCPayRequest',
    {
      appId: params.appId, //公众号名称，由商户传入
      timeStamp: params.timeStamp, //时间戳，自1970年以来的秒数
      nonceStr: params.nonceStr, //随机串
      package: params.pack,
      signType: params.signType, //微信签名方式：
      paySign: params.paySign, //微信签名
    },
    function (res) {
      if (res.err_msg == 'get_brand_wcpay_request:ok') {
        Toast('支付成功')
        window.location.href = url
      } else {
        window.location.href = url
        Toast('支付失败')
      }
    },
  )
}

// 判断环境
function getEnv() {
  let ua = window.navigator.userAgent.toLowerCase()
  return new Promise((resolve, reject) => {
    if (getUrlParam().inApp == 1 || window.navigator.userAgent.indexOf('rv2go') > -1) {
      resolve('app')
    } else if (ua.indexOf('aliapp') > -1) {
      my.getEnv((res) => {
        if (res.miniprogram) {
          resolve('zfb_mini')
        } else {
          resolve('m')
        }
      })
    } else {
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        wx.miniProgram.getEnv(function (res) {
          if (res.miniprogram) {
            resolve('mini')
          } else {
            resolve('m')
          }
        })
      } else {
        resolve('m')
      }
    }
  })
}

// 营地计算租期
function computedTimeSizeByYD(startTime, endTime) {
  let timesize = new Date(endTime.replace(/-/g, '/')).getTime() - new Date(startTime.replace(/-/g, '/')).getTime()
  let timedays = parseInt(timesize / (24 * 60 * 60 * 1000))
  return timedays
}
/**
 * @description: 证件号或手机号加密
 * @param {*} val 加密字符串
 * @return {*} 加密后字符串
 */
function desensitizedStr(val) {
  var a = val
  var b = a.slice(3, a.length - 2)
  var str = '*'
  for (var i = 0; i < b.length - 1; i++) {
    str += '*'
  }
  var c = a.replace(b, str)
  return c
}
/**
 * @description: 跳转appUrl
 * @param {*} url
 * @return {*}
 */
function appOpenUrl(url) {
  if (!isApp) return
  if (isWebAndroid) {
    window.jsObj.action_AppOpenLink(url)
  } else {
    window.webkit.messageHandlers.action_AppOpenLink.postMessage(url)
  }
}
function moneyFormat(s) {
  let n = 2
  s = parseFloat((s + '').replace(/[^\d\.-]/g, '')).toFixed(n) + ''
  var l = s.split('.')[0].split('').reverse(),
    r = s.split('.')[1]
  let t = ''
  for (let index = 0; index < l.length; index++) {
    t += l[index] + ((index + 1) % 3 == 0 && index + 1 != l.length ? ',' : '')
  }
  return t.split('').reverse().join('') + '.' + r
}
/**
 * @description: 判断m站是否内嵌在需要展示h5头部的app中
 * @return {*}
 */
const isOuterAppHeader = () => {
  let code = getCookie('commonCookie')
  let appList = ['source=1003', 'source=4006', 'source=2009', 'source=4008']
  // 一嗨首页未登录 头部兼容
  if (
    (code && appList.findIndex((e) => e === code) > -1) ||
    localStorage.oneHigh == 1 ||
    (location.href.indexOf('/rent/v2/?') > -1 && getUrlParam().channelCode == 1003)
  ) {
    return true
  }
  return false
}
// 是否隐藏h5 头部
const isHideNav = isApp || is_weixin() || !isOuterAppHeader() || getUrlParam().navigationHide == 1

async function uploadByQiniu(file, flag) {
  let tokenObj = await getQiNiuToken()
  return new Promise((resolve, reject) => {
    let config = {
      useCdnDomain: true,
    }
    const url = tokenObj.data.url
    const observer = {
      next(res) {},
      error(res) {
        reject({ success: false, flag })
      },
      complete(res) {
        resolve({ url: url + res.key, flag })
      },
    }
    const putExtra = {
      fname: '',
      params: {},
      mimeType: 'text/plain',
    }
    const token = tokenObj.data.token
    const fileType = file.name.substring(file.name.lastIndexOf('.'))
    const key = getuuid() + fileType
    const observable = qiniu.upload(file, key, token, putExtra, config)
    const subscription = observable.subscribe(observer) // 上传开始
  })
}
function getuuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}
function scrollForbidden() {
  const top = document.body.scrollTop || document.documentElement.scrollTop
  // 使body脱离文档流
  document.body.style.cssText = `position: fixed;width: 100%;top: -${top}px;`
  return top
}
function scrollEnable(top = 0) {
  document.body.style.cssText = ''
  // body回滚到之前位置
  document.body.scrollTop = document.documentElement.scrollTop = top
}

async function getMLocation() {
  let AMap = await loadMap()
  return new Promise((resolve, reject) => {
    AMap.plugin('AMap.Geolocation', function () {
      var geolocation = new AMap.Geolocation({
        enableHighAccuracy: false, // 是否使用高精度定位，默认：true
        timeout: 10000, // 设置定位超时时间，默认：无穷大
        needAddress: true,
        extensions: 'all',
      })
      geolocation.getCityInfo(function (status, result) {
        if (status == 'complete') {
          const { position = [] } = result || {}
          if (position) {
            sessionStorage.setItem(
              'currentLocation',
              JSON.stringify({
                type: 'gd', // 百度skd 返回百度坐标系
                latitude: position[1],
                longitude: position[0],
              }),
            )
          }
          resolve({
            latitude: position[1],
            longitude: position[0],
          })
        } else {
          // onError(result)
          reject(error || '高德sdk获取经纬度失败')
        }
      })
    })
  })
}
// 只获取m站中百度经纬度
async function onlyGetMLocation() {
  let local = sessionStorage.getItem('currentLocation')
  local = JSON.parse(local)
  if (local && local.type == 'gd') {
    return local
  } else {
    try {
      return (await getMLocation()) || {}
    } catch (error) {
      throw new Error(error || '高德sdk获取经纬度失败')
    }
  }
}

export const getCityLocation = async (isRefresh) => {
  if (isRefresh) {
    localStorage.removeItem('location')
    const { lat, lon, city, province } = await amapLocation()
    return {
      city: city,
      province: province,
      lat: lat,
      lon: lon,
    }
  } else {
    const position = localStorage.getItem('location')
    let lat, lon, city, province
    if (position) {
      const { lat: lat1, lon: lon1, city: cityName, province: provinceName } = JSON.parse(position)
      lat = lat1
      lon = lon1
      city = cityName
      province = provinceName
    }
    if (lat && lon && city && province) {
      return {
        city: city,
        province: province,
        lat: lat,
        lon: lon,
      }
    } else {
      try {
        const { lat, lon, city, province } = await amapLocation()
        return {
          city: city,
          province: province,
          lat: lat,
          lon: lon,
        }
      } catch (error) {
        throw new Error(error || '获取城市定位信息失败')
      }
    }
  }
}

export const amapLocation = async () => {
  // 获取城市定位信息
  let AMap = await loadMap()
  return new Promise((resolve, reject) => {
    AMap.plugin('AMap.Geolocation', function () {
      var geolocation = new AMap.Geolocation({
        enableHighAccuracy: false, // 是否使用高精度定位，默认：true
        timeout: 10000, // 设置定位超时时间，默认：无穷大
        needAddress: true,
        extensions: 'all',
      })
      geolocation.getCityInfo(function (status, result) {
        if (status == 'complete') {
          const { position = [], city, province } = result || {}
          if (position) {
            let obj = JSON.stringify({
              lat: position[1],
              lon: position[1],
              city: city,
              province: province,
            })
            localStorage.setItem('location', obj)
          }
          resolve({
            city: city,
            province: province,
            lat: position[1],
            lon: position[0],
          })
        } else {
          reject('获取城市定位信息失败')
        }
      })
    })
  })
}

//删除url中某个参数
function urlDelParameter(name) {
  var loca = window.location
  var baseUrl = loca.origin + loca.pathname
  var query = loca.search.substr(1)
  if (query.indexOf(name) > -1) {
    var obj = {}
    var arr = query.split('&')
    for (var i = 0; i < arr.length; i++) {
      arr[i] = arr[i].split('=')
      obj[arr[i][0]] = arr[i][1]
    }
    delete obj[name]
    if (JSON.stringify(obj) != '{}') {
      baseUrl = baseUrl + '?'
    }
    var url =
      baseUrl +
      JSON.stringify(obj)
        .replace(/[\"\{\}]/g, '')
        .replace(/\:/g, '=')
        .replace(/\,/g, '&')
    return url
  } else {
    return baseUrl
  }
}

function openUdesk() {
  const url = 'https://saicmotor.s2.udesk.cn/im_client/?web_plugin_id=40867&group_id=57176&language=zh-cn'
  location.href = url
}

export {
  deepCopy,
  getUrlParam,
  formatDate,
  numToCap,
  computedTimeSize,
  multiply,
  divide,
  Encrypt,
  Decrypt,
  hideNumber,
  secondFormat,
  secondFormatWithDay,
  checkPiupDropoffTime,
  getLocalCache,
  getQueryString,
  setLocalCache,
  setLocalCacheObj,
  getUrlData,
  getCookie,
  isIphone,
  isIphonXSeries,
  shareGetOpenId,
  isWXPay,
  onBridgeReady,
  computedTimeSizeByYD,
  getEnv,
  payMoneyCommon,
  desensitizedStr,
  appOpenUrl,
  moneyFormat,
  isHideNav,
  uploadByQiniu,
  scrollForbidden,
  scrollEnable,
  getMLocation,
  onlyGetMLocation,
  urlDelParameter,
  openUdesk,
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js